import { CheckIcon } from "@eventbrite/marmalade"
import * as styles from "./Recommended.module.scss"

const Recommended = () => {
  return (
    <div className={styles.recommendedBadge}>
      <div className={styles.iconWrapper}>
        <CheckIcon size="small" />
      </div>
      Recommended
    </div>
  )
}

export default Recommended
